import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoubleChevronLeftOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M26.021 2a.95.95 0 0 0-.688.296L12.74 15.316a1.02 1.02 0 0 0 0 1.422L25.334 29.76a.946.946 0 0 0 1.316-.052 1.027 1.027 0 0 0 .05-1.36l-11.895-12.31L26.709 3.729A1.02 1.02 0 0 0 27 3.012c0-.27-.105-.528-.291-.716A.95.95 0 0 0 26.021 2"
        fill="currentColor"
      />
      <path
        d="M18.567 2a.95.95 0 0 0-.688.296L5.286 15.316c-.183.188-.286.444-.286.711s.103.523.286.711L17.88 29.76a.946.946 0 0 0 1.315-.052 1.027 1.027 0 0 0 .051-1.36L7.351 16.038 19.255 3.729a1.02 1.02 0 0 0 .292-.716c0-.27-.106-.528-.292-.716A.95.95 0 0 0 18.567 2"
        fill="currentColor"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconDoubleChevronLeftOutlineSVG);
ForwardRef.displayName = "IconDoubleChevronLeftOutline";
export { ForwardRef as IconDoubleChevronLeftOutline };
